import styles from "./journalfilter.module.css";
import { useState } from "react";
import { ArrowRight, Calendar, Filter, Plus, Search } from "react-feather";
import dayjs from "dayjs";
import { DateRangePicker } from "rsuite";
import { Link } from "react-router-dom";

const JournalFilter = ({ filterDateRange, setSearchKey, setOpenAddForm, setFilterDateRange }) => {
    const [filterOpen, setFilterOpen] = useState(false);

    const disableDate = (date) => {
        const d = dayjs(date);
        //return d.isBefore(dayjs().startOf('week').subtract(4, 'week'), 'day') || d.isAfter(dayjs().endOf('week'), 'day');
        return d.isAfter(dayjs().endOf('week'), 'day');
    }

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => setSearchKey(e.target.value)} />
            </div>
        </div>

        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}>
                        <ArrowRight />
                    </span>
                </p>
                <div className={`${styles.FilterCard}`}>
                    <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
                        <DateRangePicker
                            oneTap
                            showOneCalendar
                            hoverRange="week"
                            ranges={[]}
                            format={"MM/dd/yyyy"}
                            placement={"bottomEnd"}
                            caretAs={Calendar}
                            disabledDate={disableDate}
                            cleanable={false}
                            value={filterDateRange}
                            onChange={(date) => {
                                setFilterDateRange(date);
                            }}
                        />
                    </div>
                </div>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
            <Link className={`${styles.AddNoteBu}`} onClick={(e) => setOpenAddForm(true)}>
                <Plus /> <span>Journal</span>
            </Link>
        </div>
    </div>);
};

export default JournalFilter;